$(document).ready(function() {

	/****************************************************************************************/
	/********************************** TRACKING FORM VALIDATION ****************************/
	/****************************************************************************************/

		$(".fancybox").fancybox();


		$('.track_carriage_note').click(function(e){
			e.preventDefault();
			$('#tracking').submit();
		});


		//validation and rules
		 var validator = $('#tracking').validate({
		        rules: {
		            tracking_ref: {
		                required: true,
		                remote: $('input[name="api_url"]').val()+"tracking/check_carriage_id"
		            }
		        },
		        highlight: function (element) {
		            $(element).closest('.form-group').addClass('has-error');
		        },
		        unhighlight: function (element) { // un-hightlight error inputs
				  $(element)
				  .closest('.form-group').removeClass('has-error'); 
				},
				messages: {
			        tracking_ref: {
			            required: "This field is required.",
			            remote: "Invalid tracking Ref."
			        }
			    },
			    submitHandler: function (form) { 
		            $('#fade').css('display','block');
					target = document.getElementById('fade');
					spinner = new Spinner(opts).spin(target);
					//get tracking ref
					tracking_ref = $('input[name="tracking_ref"]').val();
					//redirect to index with the tracking number
					window.location.href = base_url+"/tracking/"+tracking_ref;
		        },
		        success: function (element) {
		            element.addClass('valid')
		                .closest('.form-group').removeClass('has-error');
		                
		        }
		    });

});